import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import {
  editEmergencyContacts,
  editGaon,
  editNearPlaces,
  fetchGaonDetails,
} from "../../action/gaonApi";
import { useNavigate, useParams } from "react-router-dom";
import uploadImage from "../../action/imageUpload";
import Breadcrumb from "../../components/Breadcrumb/Breadcrumb";
import { Loader } from "../../components/loader";
import { gaonTextBasedOnRoleTYpe, getImageUrl } from "../../helper/constants";
import { Button, Modal } from "react-bootstrap";
import toast from "react-hot-toast";
import Offcanvas from "react-bootstrap/Offcanvas";
import ThumbnailPicker from "../../components/ThumbnailPicker/ThumbnailPicker";
import ImageCanvas from "../../components/gaonEditComponents/images";
import DatePicker from "react-datepicker";
import trashIcon from "../../assets/images/trash-03.svg";
import editIcon from "../../assets/images/edit-02.svg";
import showNotification from "../../components/notification/showNotification";
import { handleKeyDown } from "../../helper/helper";
import ProductManagement from "../../components/gaonEditComponents/products";
import BrowseService from "../../components/gaonEditComponents/browse_services";

const EditeGaon = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [imageCanvas, setImageCanvas] = useState(false);
  const [emergencyContacts, setEmergencyContacts] = useState([]);
  const [nearPlacesDetails, setNearPlacesDetails] = useState([]);
  const [gaonDetails, setGaonDetails] = useState({});
  const [selectedImage, setSelectedImage] = useState(null); // State for selected image
  const [showImageModal, setShowImageModal] = useState(false); // State for modal visibility
  const [visibleCount, setVisibleCount] = useState(6); // Show only 6 images initially
  const [editMode, setEditMode] = useState({
    gaonData: false,
    emergencyContact: false,
    nearbyPlaces: false,
    gramPanchayat: false,
    profile: false,
  });
  const [showAddRecordCanvas, setShowAddRecordCanvas] = useState(false);
  const [newRecord, setNewRecord] = useState({
    year: "",
    sarpanch: "",
    secretary: "",
  });
  const [selectedYear, setSelectedYear] = useState(null);
  const [isEditingContact, setIsEditingContact] = useState(false);
  const [editingContactIndex, setEditingContactIndex] = useState(null);
  const [showDeleteContactModal, setShowDeleteContactModal] = useState(false);
  const [selectedContactIndex, setSelectedContactIndex] = useState(null);
  const editGaonFormik = useFormik({
    initialValues: {
      info: "",
      name: "",
      pic: [],
      district: "",
      state: "",
      subDistrict: "",
      extras: {},
      demography: {},
      gramPanchayatInfo: {},
      stdCode: "",
      pincode: "",
      aggriculturalInfo: {},
      extras: {},
      censusId: ""
    },
    onSubmit: async (values) => {
      const { name, district, state, extras, subDistrict, ...filteredValues } =
        values;
      if (values.censusId && values.censusId.length !== 6) {
        showNotification("Census ID", "Census ID must be exactly 6 digits", "danger");
        return;
      }
      setIsLoading(true);
      setIsOpenModal(true);
    },
  });
  const getGaonDetails = async () => {
    const response = await fetchGaonDetails(id);
    if (response.status) {
      setIsLoading(false);
      setGaonDetails(response?.data);
      setEmergencyContacts(response?.data?.emergencyContacts);
      setNearPlacesDetails(response?.data?.nearPlacesDetails);
      editGaonFormik.setFieldValue("name", response.data?.name ?? "");
      editGaonFormik.setFieldValue("info", response.data?.info ?? "");
      editGaonFormik.setFieldValue("pic", response.data?.pic ?? "");
      editGaonFormik.setFieldValue("extras", response.data?.extras ?? "");
      editGaonFormik.setFieldValue("stdCode", response.data?.stdCode ?? "");
      editGaonFormik.setFieldValue("pincode", response.data?.pincode ?? "");
      editGaonFormik.setFieldValue(
        "district",
        response.data?.districtDetails.name ?? ""
      );
      editGaonFormik.setFieldValue(
        "state",
        response.data?.stateDetails.name ?? ""
      );
      editGaonFormik.setFieldValue(
        "subDistrict",
        response.data?.blockDetails.name ?? ""
      );
      editGaonFormik.setFieldValue(
        "demography",
        response.data?.demography ?? {}
      );
      editGaonFormik.setFieldValue(
        "aggriculturalInfo",
        response.data?.aggriculturalInfo ?? {}
      );
      editGaonFormik.setFieldValue(
        "gramPanchayatInfo",
        response.data?.gramPanchayatInfo ?? {}
      );
      editGaonFormik.setFieldValue("extras", response?.data?.extras ?? {});
      editGaonFormik.setFieldValue("censusId", response?.data?.censusId ?? "");
    }
  };

  const handleUpdate = async () => {
    setIsLoading(true);
    const allImages = [...currentPic, ...tempImages].slice(0, 4);

    delete editGaonFormik.values.name;
    delete editGaonFormik.values.district;
    delete editGaonFormik.values.state;
    delete editGaonFormik.values.subDistrict;

    // Prepare the data to be saved
    const saveData = {
      ...editGaonFormik.values,
      pic: allImages,
    };
    const response = await editGaon(id, saveData);
    if (response.status) {
      setIsLoading(false);
      setImageCanvas(false);

      showNotification(
        "Gaon Details",
        response?.message ? response?.message : response,
        "success"
      );
      getGaonDetails();
      handleClearImages();
    } else {
      showNotification(
        "Gaon Details",
        response.message ? response?.message : response,
        "danger"
      );
    }
    setIsOpenModal(false);
    setIsLoading(false);
  };
  const handleViewImage = (image) => {
    const imageUrl = `${process.env.REACT_APP_S3_URL}/${image}`; // Construct the image URL
    setSelectedImage(imageUrl); // Set the selected image URL
    setShowImageModal(true); // Show the modal
  };

  const [isUploading, setIsUploading] = useState(false);
  const [isAdding, setIsAdding] = useState(false);
  const [tempImages, setTempImages] = useState([]);

  const currentPic = Array.isArray(editGaonFormik.values.pic)
    ? editGaonFormik.values.pic
    : [];

  const uploadMediaImage = async (file, type) => {
    const formData = new FormData();
    formData.append("file", file);
    const res = await uploadImage(formData, "gaon");
    if (res.status) {
      const obj = {
        url: res.data[0],
        type: 2,
        h: 0,
        w: 0,
      };
      if (type == "contact") {
        editContactsFormik.setFieldValue("assets", obj);
      }
      if (type == "places") {
        editNearPlaceFormik.setFieldValue("assets", obj);
      }
      return obj;
    }
    throw new Error("Failed to upload image");
  };

  const handleImageAdd = async (file) => {
    if (currentPic.length + tempImages.length >= 4) return;

    setIsAdding(true);
    try {
      const imageObj = await uploadMediaImage(file, "");
      setTempImages((prev) => [...prev, imageObj]);
    } catch (error) {
      console.error("Error uploading image:", error);
      showNotification("Gaon Details", "Image upload failed", "success");
    } finally {
      setIsAdding(false);
    }
  };

  const handleImageDelete = (index) => {
    if (index < currentPic.length) {
      // Delete from existing images
      const updatedImages = [...currentPic];
      updatedImages.splice(index, 1);
      editGaonFormik.setFieldValue("pic", updatedImages);
    } else {
      // Delete from temp images
      const updatedTemp = [...tempImages];
      updatedTemp.splice(index - currentPic.length, 1);
      setTempImages(updatedTemp);
    }
  };

  const displayImages = [
    ...currentPic.map((img) => img?.url || ""),
    ...tempImages.map((img) => img.url),
  ].filter((url) => url);

  // Emergency contact
  const [showForm, setShowForm] = useState(false);
  const contactTypes = [
    { value: 0, label: "Police Station" },
    { value: 1, label: "Ambulance Service" },
    { value: 2, label: "Animal Shelter" },
    { value: 3, label: "Fire Station" },
  ];

  const editContactsFormik = useFormik({
    initialValues: {
      name: "",
      radius: "",
      contacts: [""],
      type: "",
      // assets: {
      //   url: "",
      //   type: 2,
      //   h: 0,
      //   w: 0,
      // },
    },
    onSubmit: async (values) => {
      try {
        // if (values.assets.url == "") {
        //   showNotification("Gaon Details", "Select Image", "danger");
        //   return;
        // }
        const filteredContacts = emergencyContacts.map(
          ({ name, type, contacts, radius, isActive }) => ({
            name,
            type,
            contacts,
            radius,
            isActive: isActive !== undefined ? isActive : true,
          })
        );

        let updatedContactsList;
        if (isEditingContact) {
          updatedContactsList = [...filteredContacts];
          updatedContactsList[editingContactIndex] = {
            ...values,
            isActive: true,
          };
        } else {
          updatedContactsList = [...filteredContacts, { ...values, isActive: true }];
        }

        const updatedContacts = {
          emergencyContactInfo: updatedContactsList,
        };
        const res = await editEmergencyContacts(id, updatedContacts);
        if (res.status) {
          setShowForm(false);
          setIsEditingContact(false);
          setEditingContactIndex(null);
          showNotification("Gaon Details", res?.message, "success");
        } else {
          showNotification(
            "Gaon Details",
            res.message ? res.message : res,
            "danger"
          );
        }
        getGaonDetails();
        editContactsFormik.handleReset();
      } catch (error) {
        console.error("Failed to add/edit category", error);
      }
    },
  });

  const onCloseToaste = () => {
    toast.dismiss();
  };

  // near places
  const placeTypeTitles = [
    "Nearest Police Station",
    "Nearest Hospital",
    "Nearest Schools and Colleges",
    "Government Office",
    "Railway Station",
    "Bus Station",
  ];
  const [selectedType, setSelectedType] = useState();
  const [openPlaceForm, setOpenPlaceForm] = useState(false);
  const [deletePlaceForm, setDeletePlaceForm] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState();

  const handleEditContact = (contact, index) => {
    setIsEditingContact(true);
    setEditingContactIndex(index);
    editContactsFormik.setValues({
      name: contact.name,
      radius: contact.radius,
      contacts: contact.contacts,
      type: contact.type,
    });
    setShowForm(true);
  };

  const handleDeleteContact = (index) => {
    setSelectedContactIndex(index);
    setShowDeleteContactModal(true);
  };

  const handleConfirmDeleteContact = async () => {
    try {
      const updatedContactsList = emergencyContacts.map((item, i) => ({
        name: item.name,
        type: item.type,
        contacts: item.contacts,
        radius: item.radius,
        isActive: i === selectedContactIndex ? false : (item.isActive !== false),
      }));

      const payload = {
        emergencyContactInfo: updatedContactsList,
      };

      const res = await editEmergencyContacts(id, payload);
      if (res.status) {
        showNotification("Gaon Details", res?.message, "success");
        getGaonDetails();
      } else {
        showNotification(
          "Gaon Details",
          res.message ? res.message : res,
          "danger"
        );
      }
    } catch (error) {
      console.error("Failed to delete contact", error);
    } finally {
      setShowDeleteContactModal(false);
      setSelectedContactIndex(null);
    }
  };

  const editNearPlaceFormik = useFormik({
    initialValues: {
      name: "",
      radius: "",
      time: "",
      assets: {
        url: "",
        type: 2,
        h: 0,
        w: 0,
      },
    },
    onSubmit: async (values) => {
      try {
        if (values.assets.url == "") {
          showNotification("Gaon Details", "Select Image", "danger");
          return;
        }

        // Check if nearPlacesDetails is empty or doesn't exist
        if (!nearPlacesDetails || nearPlacesDetails.length === 0) {
          // Initialize with the new type and place
          const updatedPlaces = [
            {
              type: Number(selectedType),
              places: [values],
            },
          ];

          const filteredPayload = updatedPlaces.map((item) => ({
            type: item.type,
            places: item.places.map((place) => ({
              name: place.name,
              time: place.time,
              radius: place.radius,
              assets: place.assets
                ? {
                  url: place.assets.url,
                  w: place.assets.w,
                  h: place.assets.h,
                }
                : null,
            })),
          }));

          await updatePlaces(id, filteredPayload);
          setOpenPlaceForm(false);
          return;
        }

        // Check if the type already exists
        const typeExists = nearPlacesDetails.some(
          (item) => item.type === Number(selectedType)
        );

        let updatedPlaces;
        if (typeExists) {
          // Type exists - append to existing places
          updatedPlaces = nearPlacesDetails.map((item) => {
            if (item.type === Number(selectedType)) {
              return {
                ...item,
                places: [...item.places, values],
              };
            }
            return item;
          });
        } else {
          // Type doesn't exist - add new type with the place
          updatedPlaces = [
            ...nearPlacesDetails,
            {
              type: Number(selectedType),
              places: [values],
            },
          ];
        }

        const filteredPayload = updatedPlaces.map((item) => ({
          type: item.type,
          places: item.places.map((place) => ({
            name: place.name,
            time: place.time,
            radius: place.radius,
            assets: place.assets
              ? {
                url: place.assets.url,
                w: place.assets.w,
                h: place.assets.h,
              }
              : null,
          })),
        }));

        await updatePlaces(id, filteredPayload);
        setOpenPlaceForm(false);
      } catch (error) {
        console.error("Failed to add category", error);
      }
    },
  });

  const updatePlaces = async (id, values) => {
    const payload = { nearPlacesInfo: values };
    const res = await editNearPlaces(id, payload);

    if (res.status) {
      setShowForm(false);
      showNotification("Gaon Details", res?.message, "success");
    } else {
      showNotification(
        "Gaon Details",
        res.message ? res.message : res,
        "danger"
      );
    }
    getGaonDetails();
    editNearPlaceFormik.handleReset();
  };

  const handleDelete = () => {
    const updatedPlaces = nearPlacesDetails.map((item) =>
      item.type === Number(selectedType)
        ? { ...item, places: item.places.filter((_, i) => i !== selectedIndex) }
        : item
    );

    setNearPlacesDetails(updatedPlaces);
    const filteredPayload = updatedPlaces.map((item) => ({
      type: item.type,
      places: item.places.map((place) => ({
        name: place.name,
        time: place.time,
        assets: place.assets
          ? {
            url: place.assets.url,
            w: place.assets.w,
            h: place.assets.h,
          }
          : null,
        radius: place.radius,
      })),
    }));
    setDeletePlaceForm(false);
    updatePlaces(id, filteredPayload);
  };

  const isGramPanchayatFormValid = () => {
    const info = editGaonFormik.values.gramPanchayatInfo;

    const requiredFields = [
      info.constituentAssembly,
      info.assemblyMLA,
      info.lokSabhaConstituency,
      info.parliamentMP,
      info.sarpanch,
      info.secretary,
    ];

    const areFieldsFilled = requiredFields.every(
      (field) => field && field.trim() !== ""
    );
    const hasPreviousData =
      Array.isArray(info.previousData) && info.previousData.length > 0;

    return areFieldsFilled && hasPreviousData;
  };

  const handleClearImages = () => {
    setTempImages([]); // Clear temporary images
  };

  const allTypes = [0, 1, 2, 3, 4, 5];

  const filteredContactTypes = contactTypes.filter((type) => {
    if (isEditingContact && editingContactIndex !== null) {
      if (emergencyContacts[editingContactIndex]?.type === type.value) {
        return true;
      }
    }
    return !emergencyContacts.some(
      (c) => c.type === type.value && c.isActive !== false
    );
  });

  useEffect(() => {
    getGaonDetails();
  }, []);

  return (
    <div className="payout_data-content">
      <div className="payout_data-head">
        <div className="payout_data-head-top p-0">
          <div className="payout_data-left">
            <div className="payout_data_ttl">
              <Breadcrumb
                paths={[
                  {
                    name: gaonTextBasedOnRoleTYpe() + " Details",
                    link: `/gaon/details/${id}`,
                  },
                  {
                    name: "Edit " + gaonTextBasedOnRoleTYpe(),
                    link: "/gaon/edit",
                  },
                ]}
              />
            </div>
          </div>
        </div>
      </div>
      {isLoading && <Loader />}
      <div className="tab_box">
        <form onSubmit={editGaonFormik.handleSubmit} className="">
          <div className="row">
            <div className="col-lg-6">
              <div className="input-box">
                <div className="input-label">Gaon Name</div>
                <div className="input_field">
                  <input
                    type="text"
                    className="input"
                    name="name"
                    placeholder={`Enter ${gaonTextBasedOnRoleTYpe()} name`}
                    value={editGaonFormik.values.name}
                    readOnly={true}
                  />
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="input-box">
                <div className="input-label">Sub District</div>
                <div className="input_field">
                  <input
                    className="input"
                    type="text"
                    placeholder="Enter Subdistrict"
                    name="block"
                    value={editGaonFormik.values.subDistrict}
                    readOnly={true}
                  />
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="input-box">
                <div className="input-label">District</div>
                <div className="input_field">
                  <input
                    className="input"
                    type="text"
                    placeholder="Enter district"
                    name="district"
                    value={editGaonFormik.values.district}
                    readOnly={true}
                  />
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="input-box">
                <div className="input-label">State</div>
                <div className="input_field">
                  <input
                    className="input"
                    type="text"
                    placeholder="Enter state"
                    name="state"
                    value={editGaonFormik.values.state}
                    readOnly={true}
                  />
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="input-box">
                <div className="input-label">Population</div>
                <div className="input_field">
                  <input
                    type="text"
                    className="input"
                    name="population"
                    placeholder="Enter Population"
                    value={editGaonFormik.values?.demography?.population}
                    onChange={(e) => {
                      editGaonFormik.setFieldValue(
                        "demography.population",
                        e.target.value
                      );
                    }}
                    onKeyDown={handleKeyDown}
                  />
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="input-box">
                <div className="input-label">Pin Code</div>
                <div className="input_field">
                  <input
                    type="text"
                    className="input"
                    name="pincode"
                    value={editGaonFormik.values?.pincode}
                    onChange={(e) => {
                      editGaonFormik.setFieldValue("pincode", e.target.value);
                    }}
                    maxLength={6}
                    onKeyDown={handleKeyDown}
                  />
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="input-box">
                <div className="input-label">STD Code</div>
                <div className="input_field">
                  <input
                    type="text"
                    className="input"
                    name="stdCode"
                    value={editGaonFormik.values?.stdCode}
                    onChange={(e) => {
                      editGaonFormik.setFieldValue("stdCode", e.target.value);
                    }}
                    maxLength={5}
                    minLength={3}
                    onKeyDown={handleKeyDown}
                  />
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="input-box">
                <div className="input-label">Census ID</div>
                <div className="input_field">
                  <input
                    type="text"
                    className="input"
                    name="censusId"
                    value={editGaonFormik.values?.censusId}
                    onChange={(e) => {
                      editGaonFormik.setFieldValue("censusId", e.target.value);
                    }}
                    length={6}
                    onKeyDown={handleKeyDown}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="row mt-2">
            <div className="col-lg-12">
              <div className="input-box">
                <div className="input-label">About {gaonDetails?.name} </div>
                <textarea
                  className="textarea_input"
                  rows={9}
                  cols={20}
                  name="info"
                  placeholder="Enter gaon info"
                  value={editGaonFormik?.values?.info}
                  onChange={(e) => {
                    editGaonFormik.setFieldValue("info", e.target.value);
                  }}
                  required
                >
                  {editGaonFormik?.values?.info}
                </textarea>
              </div>
            </div>
          </div>
          <div className="row mt-2">
            <div className="col-lg-12">
              <div className="input-box">
                <div className="input-label">Agriculture Information</div>
                <textarea
                  className="textarea_input"
                  rows={5}
                  name="desc"
                  value={editGaonFormik?.values?.aggriculturalInfo?.desc}
                  style={{
                    resize: "none",
                  }}
                  onChange={(e) => {
                    editGaonFormik.setFieldValue(
                      "aggriculturalInfo.desc",
                      e.target.value
                    );
                  }}
                >
                  {gaonDetails?.info}
                </textarea>
              </div>
            </div>
          </div>
          <div className="row mt-2">
            <div className="col-lg-12">
              <div className="input-box">
                <div className="d-flex justify-content-between me-2">
                  <div className="input-label">Notice</div>
                  <div className="toggle-switch ms-4 contest_toggle">
                    <input
                      type="checkbox"
                      id="notice"
                      className="toggle-checkbox"
                      checked={editGaonFormik?.values?.extras?.showNotice}
                      onChange={(e) => {
                        editGaonFormik.setFieldValue(
                          "extras.showNotice",
                          !editGaonFormik?.values?.extras?.showNotice
                        );
                      }}
                    />
                    <label for="notice" className="toggle-label"></label>
                  </div>
                </div>

                <textarea
                  className="textarea_input"
                  rows={5}
                  name="extras.notice"
                  value={editGaonFormik?.values?.extras?.notice}
                  placeholder="Enter notice here"
                  style={{
                    resize: "none",
                  }}
                  onChange={(e) => {
                    editGaonFormik.setFieldValue(
                      "extras.notice",
                      e.target.value
                    );
                  }}
                >
                  {editGaonFormik?.values?.extras?.notice}
                </textarea>
              </div>
            </div>
          </div>
          <div class="payout_inner_content mt-4">
            <div class="payout_data-content tablePage_content_header">
              <div class="address_section">
                <div class="address_div">
                  <div class="address_label">
                    <h4>images of {gaonDetails?.name} </h4>
                    <div
                      style={{ display: "flex", justifyContent: "flex-end" }}
                    >
                      <button
                        type="button"
                        isLight
                        className="btn btn-success"
                        onClick={() => {
                          setImageCanvas(!imageCanvas);
                        }}
                      >
                        {editGaonFormik.values.pic.length == 4
                          ? "Update images"
                          : editGaonFormik.values.pic.length >= 1
                            ? "Add More images"
                            : "Add Image"}
                      </button>{" "}
                    </div>
                  </div>
                  <div class="address_option">
                    <div className="gaonImage_container">
                      {gaonDetails?.pic?.length > 0 ? (
                        gaonDetails?.pic
                          .slice(0, visibleCount)
                          .map((value, index) => (
                            <div className="showGaonImg gaonImg" key={index}>
                              <img
                                src={`${process.env.REACT_APP_S3_URL}/${value.url}`}
                                alt="Preview"
                                onClick={() => handleViewImage(value.url)}
                              />
                            </div>
                          ))
                      ) : (
                        <p>No images available</p>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* <div className="profile_submit_div">
            <button type="submit" className="btn btn-success">
              Save
            </button>
          </div> */}

          <div className="payout_inner_content mt-4">
            <div className="payout_data-content tablePage_content_header">
              <div className="address_section">
                <div className="address_div">
                  <div className="address_label">
                    <h4>About Gram Panchayat</h4>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "flex-end",
                        gap: "10px",
                      }}
                    ></div>
                  </div>
                  <div className="address_option">
                    <div className="row">
                      <div className="col-lg-6">
                        <div className="input-box">
                          <div className="input-label">
                            Constituent Assembly
                          </div>
                          <div className="input_field">
                            <input
                              type="text"
                              className="input"
                              name="gramPanchayatInfo.constituentAssembly"
                              value={
                                editGaonFormik.values.gramPanchayatInfo
                                  ?.constituentAssembly || ""
                              }
                              onChange={editGaonFormik.handleChange}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="input-box">
                          <div className="input-label">Assembly MLA</div>
                          <div className="input_field">
                            <input
                              type="text"
                              className="input"
                              name="gramPanchayatInfo.assemblyMLA"
                              value={
                                editGaonFormik.values.gramPanchayatInfo
                                  ?.assemblyMLA || ""
                              }
                              onChange={editGaonFormik.handleChange}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="input-box">
                          <div className="input-label">
                            Lok Sabha Constituency
                          </div>
                          <div className="input_field">
                            <input
                              type="text"
                              className="input"
                              name="gramPanchayatInfo.lokSabhaConstituency"
                              value={
                                editGaonFormik.values.gramPanchayatInfo
                                  ?.lokSabhaConstituency || ""
                              }
                              onChange={editGaonFormik.handleChange}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="input-box">
                          <div className="input-label">Parliament MP</div>
                          <div className="input_field">
                            <input
                              type="text"
                              className="input"
                              name="gramPanchayatInfo.parliamentMP"
                              value={
                                editGaonFormik.values.gramPanchayatInfo
                                  ?.parliamentMP || ""
                              }
                              onChange={editGaonFormik.handleChange}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="input-box">
                          <div className="input-label">Sarpanch</div>
                          <div className="input_field">
                            <input
                              type="text"
                              className="input"
                              name="gramPanchayatInfo.sarpanch"
                              value={
                                editGaonFormik.values.gramPanchayatInfo
                                  ?.sarpanch || ""
                              }
                              onChange={editGaonFormik.handleChange}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="input-box">
                          <div className="input-label">Secretary</div>
                          <div className="input_field">
                            <input
                              type="text"
                              className="input"
                              name="gramPanchayatInfo.secretary"
                              value={
                                editGaonFormik.values.gramPanchayatInfo
                                  ?.secretary || ""
                              }
                              onChange={editGaonFormik.handleChange}
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                    <table className="payout_table upi-mandate_table mt-4">
                      <thead>
                        <tr className="tableHead">
                          <th className="thHeader">Year</th>
                          <th className="thHeader">Sarpanch</th>
                          <th className="thHeader">Secretary</th>
                          <th className="thHeader">Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {editGaonFormik?.values?.gramPanchayatInfo?.previousData?.map(
                          (item, i) => (
                            <tr key={i}>
                              <td>
                                {editMode.gramPanchayat ? (
                                  <input
                                    type="text"
                                    className="input"
                                    value={item.year}
                                    onChange={(e) => {
                                      const updatedData = [
                                        ...editGaonFormik.values
                                          .gramPanchayatInfo?.previousData,
                                      ];
                                      updatedData[i].year = e.target.value;
                                      editGaonFormik.setFieldValue(
                                        "gramPanchayatInfo.previousData",
                                        updatedData
                                      );
                                    }}
                                  />
                                ) : (
                                  item?.year
                                )}
                              </td>
                              <td>
                                {editMode.gramPanchayat ? (
                                  <input
                                    type="text"
                                    className="input"
                                    value={item?.sarpanch}
                                    onChange={(e) => {
                                      const updatedData = [
                                        ...editGaonFormik.values
                                          .gramPanchayatInfo?.previousData,
                                      ];
                                      updatedData[i].sarpanch = e.target.value;
                                      editGaonFormik.setFieldValue(
                                        "gramPanchayatInfo.previousData",
                                        updatedData
                                      );
                                    }}
                                  />
                                ) : (
                                  item?.sarpanch
                                )}
                              </td>
                              <td>
                                {editMode.gramPanchayat ? (
                                  <input
                                    type="text"
                                    className="input"
                                    value={item.secretary}
                                    onChange={(e) => {
                                      const updatedData = [
                                        ...editGaonFormik.values
                                          .gramPanchayatInfo?.previousData,
                                      ];
                                      updatedData[i].secretary = e.target.value;
                                      editGaonFormik.setFieldValue(
                                        "gramPanchayatInfo.previousData",
                                        updatedData
                                      );
                                    }}
                                  />
                                ) : (
                                  item?.secretary
                                )}
                              </td>
                              <td>
                                <button
                                  className="action_btn1"
                                  onClick={() => {
                                    const updatedData =
                                      editGaonFormik.values.gramPanchayatInfo.previousData.filter(
                                        (_, idx) => idx !== i
                                      );
                                    editGaonFormik.setFieldValue(
                                      "gramPanchayatInfo.previousData",
                                      updatedData
                                    );
                                  }}
                                >
                                  <img src={trashIcon} alt="delete" />
                                </button>
                              </td>
                            </tr>
                          )
                        )}
                      </tbody>
                    </table>

                    <div className="profile_submit_div mt-2">
                      <button
                        type="button"
                        className="btn btn-success"
                        onClick={() => setShowAddRecordCanvas(true)}
                      >
                        {editGaonFormik.values.gramPanchayatInfo.previousData
                          ?.length > 0
                          ? "Add More"
                          : "Add Record"}
                      </button>
                      <button
                        type="submit"
                        className="btn btn-success"
                        // disabled={!isGramPanchayatFormValid()}
                        onClick={() => {
                          setEditMode((prev) => ({
                            ...prev,
                            gramPanchayat: false,
                          }));
                          editGaonFormik.handleSubmit();
                        }}
                      >
                        Save All Details
                      </button>
                      <button
                        type="button"
                        className="btn btn-dark"
                        onClick={() => {
                          setEditMode((prev) => ({
                            ...prev,
                            gramPanchayat: false,
                          }));
                          // Reset to original values if needed
                          editGaonFormik.setValues({
                            ...editGaonFormik.values,
                            gramPanchayatInfo:
                              gaonDetails?.gramPanchayatInfo || {
                                constituentAssembly: "",
                                assemblyMLA: "",
                                previousData: [],
                              },
                          });
                        }}
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
        {/* Products */}
        <ProductManagement gaonId={id} />
        {/* Browse Services */}
        <BrowseService id={id} />
        {/* Emergency Contacts */}
        <div class="payout_inner_content mt-2">
          <div class="payout_data-content tablePage_content_header">
            <div class="address_section">
              <div class="address_div">
                <div class="address_label">
                  <h4>Emergency Contact </h4>
                  <div style={{ display: "flex", justifyContent: "flex-end" }}>
                    <button
                      type="button"
                      className="btn btn-primary"
                      onClick={() => {
                        setIsEditingContact(false);
                        setEditingContactIndex(null);
                        editContactsFormik.handleReset();
                        setShowForm(true);
                      }}
                    >
                      Add New
                    </button>
                  </div>
                </div>
                <div class="address_option">
                  <table className="payout_table upi-mandate_table">
                    <thead>
                      <tr className="tableHead">
                        <th className="thHeader">Icon</th>
                        <th className="thHeader">Name</th>
                        <th className="thHeader">
                          Contact | Alternate Contacts
                        </th>
                        <th className="thHeader">Radius</th>
                        <th className="thHeader">Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {emergencyContacts &&
                        emergencyContacts.filter((c) => c.isActive !== false)
                          .length > 0 ? (
                        emergencyContacts
                          .map((item, i) => ({ ...item, originalIndex: i }))
                          .filter((item) => item.isActive !== false)
                          .map((item, i) => (
                            <tr key={i}>
                              <td>
                                { }
                                <img
                                  src={
                                    gaonDetails?.emergencyContactIcons?.[
                                      item?.type
                                    ]
                                      ? getImageUrl(
                                        gaonDetails?.emergencyContactIcons?.[
                                        item?.type
                                        ]
                                      )
                                      : ""
                                  }
                                  style={{
                                    width: "50px",
                                    maxHeight: "50px",
                                    objectFit: "contain",
                                  }}
                                />
                              </td>
                              <td>{item?.name}</td>
                              <td>
                                {item?.contacts?.map((c, index) => (
                                  <span key={index}>
                                    {c}
                                    {index !== item.contacts.length - 1 &&
                                      " | "}
                                  </span>
                                ))}
                              </td>
                              <td>{item?.radius}</td>
                              <td>
                                <button
                                  className="action_btn1"
                                  onClick={() =>
                                    handleEditContact(item, item.originalIndex)
                                  }
                                >
                                  <img src={editIcon} alt="edit" />
                                </button>
                                <button
                                  className="action_btn1"
                                  onClick={() =>
                                    handleDeleteContact(item.originalIndex)
                                  }
                                >
                                  <img src={trashIcon} alt="delete" />
                                </button>
                              </td>
                            </tr>
                          ))
                      ) : (
                        <>
                          <tr>
                            <td colspan="11" className="text_center">
                              No data found
                            </td>
                          </tr>
                        </>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
        {nearPlacesDetails?.map((data) => {
          const typeIndex = data?.type;
          if (typeIndex < 0 || typeIndex > 5) return null;

          return (
            <div
              className="payout_inner_content mt-4"
              key={`type-${typeIndex}`}
            >
              <div className="payout_data-content tablePage_content_header">
                <div className="address_section">
                  <div className="address_div">
                    <div className="address_label">
                      <h4>{placeTypeTitles[typeIndex]}</h4>
                      <div
                        style={{ display: "flex", justifyContent: "flex-end" }}
                      >
                        <button
                          className="btn btn-primary"
                          type="button"
                          onClick={() => {
                            // handleAddNew(typeIndex)
                            setOpenPlaceForm(true);
                            setSelectedType(typeIndex);
                          }}
                        >
                          Add New
                        </button>
                      </div>
                    </div>
                    <div className="address_option">
                      <table className="payout_table upi-mandate_table">
                        <thead>
                          <tr className="tableHead">
                            <th className="thHeader">
                              <div className="payoutHead hndIcon">Name</div>
                            </th>
                            <th className="thHeader">
                              <div className="payoutHead hndIcon">Radius</div>
                            </th>
                            <th className="thHeader">
                              <div className="payoutHead hndIcon">Time</div>
                            </th>
                            <th className="thHeader">
                              <div className="payoutHead hndIcon">Image</div>
                            </th>
                            <th className="thHeader">
                              <div className="payoutHead hndIcon">Actions</div>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {isLoading ? (
                            <tr>
                              <td colSpan="5">
                                <Loader />
                              </td>
                            </tr>
                          ) : data?.places?.length > 0 ? (
                            data.places.map((item, i) => (
                              <tr key={`place-${typeIndex}-${i}`}>
                                <td>{item?.name}</td>
                                <td>{item?.radius}</td>
                                <td>{item?.time || "N/A"}</td>
                                <td>
                                  {item?.assets?.url ? (
                                    <img
                                      src={getImageUrl(item.assets.url)}
                                      alt=""
                                      className="nearbyImg"
                                      style={{
                                        width: "50px",
                                        height: "50px",
                                        objectFit: "cover",
                                      }}
                                    />
                                  ) : (
                                    "No image"
                                  )}
                                </td>
                                <td>
                                  <button
                                    className="action_btn1"
                                    onClick={() => {
                                      setDeletePlaceForm(true);
                                      setSelectedType(typeIndex);
                                      setSelectedIndex(i);
                                    }}
                                  >
                                    <img src={trashIcon} alt="delete" />
                                  </button>
                                </td>
                              </tr>
                            ))
                          ) : (
                            <>
                              <tr>
                                <td colspan="11" className="text_center">
                                  No data found
                                </td>
                              </tr>
                            </>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
        {/* near placess */}
        {/* Render "Add" buttons for missing types */}
        {allTypes
          .filter(
            (type) => !nearPlacesDetails?.some((data) => data?.type === type)
          )
          .map((missingType) => (
            <div
              className="payout_inner_content mt-4"
              key={`missing-type-${missingType}`}
            >
              <div className="payout_data-content tablePage_content_header">
                <div className="address_section">
                  <div className="address_div">
                    <div className="address_label">
                      <h4>{placeTypeTitles[missingType]}</h4>
                      <div
                        style={{ display: "flex", justifyContent: "flex-end" }}
                      >
                        <button
                          className="btn btn-primary"
                          type="button"
                          onClick={() => {
                            setOpenPlaceForm(true);
                            setSelectedType(missingType);
                          }}
                        >
                          Add New
                        </button>
                      </div>
                    </div>
                    <div className="address_option">
                      <table className="payout_table upi-mandate_table">
                        <tbody>
                          <tr>
                            <td colSpan="5" className="text_center">
                              No data found
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        <Modal show={isOpenModal} onHide={() => setIsOpenModal(false)}>
          <Modal.Header closeButton>
            <Modal.Title>Update</Modal.Title>
          </Modal.Header>
          <Modal.Body>Are you sure you want to update?</Modal.Body>
          <Modal.Footer>
            <Button
              className="btn btn-dark"
              variant="secondary"
              onClick={() => setIsOpenModal(false)}
            >
              No
            </Button>
            <Button
              className="btn btn-success"
              variant="primary"
              onClick={handleUpdate}
            >
              Yes
            </Button>
          </Modal.Footer>
        </Modal>
        <Modal
          show={showDeleteContactModal}
          onHide={() => setShowDeleteContactModal(false)}
        >
          <Modal.Header closeButton>
            <Modal.Title>Delete Emergency Contact</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            Are you sure you want to delete this emergency contact?
          </Modal.Body>
          <Modal.Footer>
            <Button
              className="btn btn-dark"
              variant="secondary"
              onClick={() => setShowDeleteContactModal(false)}
            >
              No
            </Button>
            <Button
              className="btn btn-danger"
              variant="primary"
              onClick={handleConfirmDeleteContact}
            >
              Yes, Delete
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Gaon image */}
        <ImageCanvas
          show={imageCanvas}
          onHide={() => !isUploading && setImageCanvas(false)}
          images={displayImages}
          onImageAdd={handleImageAdd}
          onImageDelete={handleImageDelete}
          onSave={handleUpdate}
          isUploading={isUploading}
          isAdding={isAdding}
          onClear={handleClearImages}
        />

        {/* Add Record Canvas */}
        <Offcanvas
          show={showAddRecordCanvas}
          onHide={() => {
            setShowAddRecordCanvas(false);
            setSelectedYear();
          }}
          placement="end"
        >
          <Offcanvas.Header closeButton>
            <Offcanvas.Title>Add New Record</Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>
            <div className="px-3">
              <div className="row">
                <div className="col-12">
                  <div className="input-group1">
                    <div className="input-label">Year</div>
                    <div className="date-picker-comp ">
                      <DatePicker
                        selected={selectedYear}
                        onChange={(date) => {
                          setSelectedYear(date);
                          setNewRecord({
                            ...newRecord,
                            year: date ? date.getFullYear().toString() : "",
                          });
                        }}
                        showYearPicker
                        dateFormat="yyyy"
                        yearItemNumber={12}
                        className="date-picker"
                        placeholderText="Select year"
                        required
                      />
                    </div>
                  </div>
                </div>
                <div className="col-12 mt-3">
                  <div className="input-group1">
                    <div className="input-label">Sarpanch</div>
                    <div className="input_field">
                      <input
                        type="text"
                        placeholder="Enter sarpanch name"
                        className="input"
                        value={newRecord.sarpanch}
                        onChange={(e) =>
                          setNewRecord({
                            ...newRecord,
                            sarpanch: e.target.value,
                          })
                        }
                        required
                      />
                    </div>
                  </div>
                </div>
                <div className="col-12 mt-3">
                  <div className="input-group1">
                    <div className="input-label">Secretary</div>
                    <div className="input_field">
                      <input
                        type="text"
                        className="input"
                        placeholder="Enter secretary name"
                        value={newRecord.secretary}
                        onChange={(e) =>
                          setNewRecord({
                            ...newRecord,
                            secretary: e.target.value,
                          })
                        }
                        required
                      />
                    </div>
                  </div>
                </div>
                <div className="col-12 mt-4">
                  <button
                    type="button"
                    className="btn btn-success"
                    onClick={() => {
                      if (
                        !newRecord.year ||
                        !newRecord.sarpanch ||
                        !newRecord.secretary
                      ) {
                        alert("Please fill out all required fields.");
                        return;
                      }

                      const updatedData = [
                        ...(editGaonFormik.values.gramPanchayatInfo
                          ?.previousData || []),
                        newRecord,
                      ];
                      editGaonFormik.setFieldValue(
                        "gramPanchayatInfo.previousData",
                        updatedData
                      );
                      setNewRecord({ year: "", sarpanch: "", secretary: "" });
                      setSelectedYear();
                      setShowAddRecordCanvas(false);
                    }}
                  >
                    Add Record
                  </button>
                </div>
              </div>
            </div>
          </Offcanvas.Body>
        </Offcanvas>

        {/* Update emergenecy contacts */}
        <Offcanvas
          show={showForm}
          onHide={() => {
            setShowForm(false);
            editContactsFormik.handleReset();
          }}
          placement="end"
        >
          <Offcanvas.Header closeButton>
            <Offcanvas.Title>Emergency Contacts</Offcanvas.Title>
          </Offcanvas.Header>

          <Offcanvas.Body>
            <div className="add_buyer_content">
              <form action="" onSubmit={editContactsFormik.handleSubmit}>
                <div class="row">
                  <div className="col-12">
                    <div className="input-box">
                      <div className="input-label">Type</div>
                      <select
                        className="custom_dropdn"
                        value={editContactsFormik.values.type}
                        onChange={(e) => {
                          const val = e.target.value;
                          if (val === "") {
                            editContactsFormik.setFieldValue("type", "");
                            editContactsFormik.setFieldValue("name", "");
                            return;
                          }
                          const numericType = Number(val);
                          editContactsFormik.setFieldValue("type", numericType);

                          const selectedLabel =
                            contactTypes.find((type) => type.value === numericType)
                              ?.label || "";

                          editContactsFormik.setFieldValue("name", selectedLabel);
                        }}
                        disabled={isEditingContact}
                        required
                      >
                        <option value="">Select Type</option>
                        {filteredContactTypes.map((type) => (
                          <option key={type.value} value={type.value}>
                            {type.label}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="input-box">
                      <div className="input-box">
                        <div className="input-label">Distance</div>
                        <div className="input_field">
                          <input
                            type="text"
                            className="input"
                            name="radius"
                            placeholder="Enter distance"
                            value={editContactsFormik.values.radius}
                            onChange={(e) => {
                              editContactsFormik.setFieldValue(
                                "radius",
                                e.target.value
                              );
                            }}
                            required
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="input-box">
                      <div className="input-box">
                        <div className="input-label">Contact</div>
                        <div className="input_field">
                          <input
                            type="text"
                            className="input"
                            name="contacts[0]"
                            placeholder="Enter contact"
                            value={
                              editContactsFormik.values.contacts?.[0] || ""
                            }
                            onChange={(e) => {
                              const updatedContacts = [
                                ...(editContactsFormik.values.contacts || []),
                              ];
                              updatedContacts[0] = e.target.value;
                              editContactsFormik.setFieldValue(
                                "contacts",
                                updatedContacts
                              );
                            }}
                            onKeyDown={handleKeyDown}
                            required
                            maxLength={10}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="input-box">
                      <div className="input-box">
                        <div className="input-label">Alternate Contact</div>
                        <div className="input_field">
                          <input
                            type="text"
                            className="input"
                            name="contacts[1]"
                            placeholder="Enter alternate contact"
                            value={
                              editContactsFormik.values.contacts?.[1] || ""
                            }
                            onChange={(e) => {
                              const updatedContacts = [
                                ...(editContactsFormik.values.contacts || []),
                              ];
                              updatedContacts[1] = e.target.value;
                              editContactsFormik.setFieldValue(
                                "contacts",
                                updatedContacts
                              );
                            }}
                            onKeyDown={handleKeyDown}
                            maxLength={10}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* <div className="col-12">
                    <div className="input-box">
                      <div className="input-box">
                        <div className="input-label">Icon</div>
                        <div className="input_field">
                          <ThumbnailPicker
                            width="100px%"
                            height="250px"
                            onFileSelect={(file) => {
                              const _URL = window.URL || window.webkitURL;

                              const img = new Image();
                              uploadMediaImage(file, "contact");

                              img.src = _URL.createObjectURL(file);
                            }}
                            image={editContactsFormik.values?.assets?.url}
                            accept={"image/*"}
                          />
                        </div>
                      </div>
                    </div>
                  </div> */}
                </div>
                <div className="flex_btn mt-3 ">
                  <button className="btn btn-success" type="submit">
                    Save
                  </button>
                  <button
                    className="btn btn-danger"
                    type="button"
                    onClick={() => {
                      setShowForm(false);
                      editContactsFormik.handleReset();
                    }}
                  >
                    Cancel
                  </button>
                </div>
              </form>
            </div>
          </Offcanvas.Body>
        </Offcanvas>

        {/* Update near places */}
        <Offcanvas
          show={openPlaceForm}
          onHide={() => {
            setOpenPlaceForm(false);
            editNearPlaceFormik.handleReset();
          }}
          placement="end"
        >
          <Offcanvas.Header closeButton>
            <Offcanvas.Title>
              Add {placeTypeTitles[selectedType]}
            </Offcanvas.Title>
          </Offcanvas.Header>

          <Offcanvas.Body>
            <div className="add_buyer_content">
              <form action="" onSubmit={editNearPlaceFormik.handleSubmit}>
                <div class="row">
                  <div className="col-12">
                    <div className="input-box">
                      <div className="input-label">Place Name</div>
                      <div className="input_field">
                        <input
                          type="text"
                          className="input"
                          name="name"
                          placeholder="Enter place name"
                          value={editNearPlaceFormik.values.name}
                          onChange={(e) => {
                            editNearPlaceFormik.setFieldValue(
                              "name",
                              e.target.value
                            );
                          }}
                          required
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="input-box">
                      <div className="input-box">
                        <div className="input-label">Distance</div>
                        <div className="input_field">
                          <input
                            type="text"
                            className="input"
                            name="radius"
                            placeholder="Enter distance"
                            value={editNearPlaceFormik.values.radius}
                            onChange={(e) => {
                              editNearPlaceFormik.setFieldValue(
                                "radius",
                                e.target.value
                              );
                            }}
                            required
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="input-box">
                      <div className="input-box">
                        <div className="input-label">Time</div>
                        <div className="input_field">
                          <input
                            type="text"
                            className="input"
                            name="time"
                            placeholder="Enter time"
                            value={editNearPlaceFormik.values.time}
                            onChange={(e) => {
                              editNearPlaceFormik.setFieldValue(
                                "time",
                                e.target.value
                              );
                            }}
                            required
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="input-box">
                      <div className="input-box">
                        <div className="input-label">Icon</div>
                        <div className="input_field">
                          <ThumbnailPicker
                            width="100px%"
                            height="250px"
                            onFileSelect={(file) => {
                              const _URL = window.URL || window.webkitURL;

                              const img = new Image();
                              uploadMediaImage(file, "places");

                              img.src = _URL.createObjectURL(file);
                            }}
                            image={editNearPlaceFormik.values?.assets?.url}
                            accept={"image/*"}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="flex_btn mt-3 ">
                  <button className="btn btn-success" type="submit">
                    Save
                  </button>
                </div>
              </form>
            </div>
          </Offcanvas.Body>
        </Offcanvas>

        {/* Delete near places confirmation model*/}
        <Modal show={deletePlaceForm} onHide={() => setDeletePlaceForm(false)}>
          <Modal.Header closeButton>
            <Modal.Title>Delete</Modal.Title>
          </Modal.Header>
          <Modal.Body>Are you sure you want to delete this place?</Modal.Body>
          <Modal.Footer>
            <Button
              className="btn btn-dark"
              variant="secondary"
              onClick={() => setDeletePlaceForm(false)}
            >
              No
            </Button>
            <Button
              className="btn btn-success"
              variant="primary"
              onClick={handleDelete}
            >
              Yes
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </div>
  );
};

export default EditeGaon;
